import _ from 'lodash'
import Service from '@/request/base'
import moment from 'moment'
const logo = require('@/assets/logo.png')
const notphoto = require('@/assets/noimage.jpg')
const textphoto = require('@/assets/text-img.png')

const headimgFilter = (value) => {
    if (!value) {
        return logo
    }
    return Service.url(value)
}

const imageFilter = (value) => {
    if (!value) {
        return notphoto
    }
    return Service.url(value)
}

const imageParagraphFilter = (value) => {
    if (!value) {
        return textphoto
    }
    return Service.url(value)
}

const dynamicTimeFilter = (value) => {
    if (!value) {
        return '未知时间'
    }
    if (Object.prototype.toString.call(value) === '[object String]') {
        return value
    }
    if (value === '' || isNaN(value)) {
        return '未知时间'
    }
    if (value <= 0) {
        return '未知时间'
    }
    if (value < 10000000000) {
        value *= 1000
    }
    let time = new Date(value)
    let tY = time.getFullYear()
    let tM = time.getMonth() + 1 < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
    let tD = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
    let th = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
    let tm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
    let ts = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds()
    let now = new Date()
    let nY = now.getFullYear()
    let nM = now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : now.getMonth() + 1
    let nD = now.getDate() < 10 ? '0' + now.getDate() : now.getDate()
    let result = ''
    if (tY !== nY) {
        result += tY + '年'
    }
    if (tM !== nM || tD !== nD) {
        result += tM + '月'
        result += tD + '日'
    }
    if (result === '') {
        result = th + ':' + tm + ':' + ts
    }
    return result
}

const dateTimeFilter = (value, pattern) => {
    if (!value) {
        return ''
    }
    if (!pattern) {
        pattern = 'YYYY-MM-DD HH:mm:ss';
    }
    return moment(value).format(pattern)
}

const dateFilter = (value, pattern) => {
    if (!value) {
        return ''
    }
    if (!pattern) {
        pattern = 'YYYY-MM-DD';
    }
    return moment(value).format(pattern)
}

const sexFilter = (value) => {
    if (!value) {
        return '男'
    }
    if (value === '男' || value === '女') {
        return value
    }
    if (_.isInteger(value)) {
        return value % 2 === 0 ? '女' : '男'
    }
    if (value === 'F' || value === 'f') {
        return '女'
    }
    if (value === 'M' || value === 'm') {
        return '男'
    }
    return value
}

const replaceFilter = (value, start, stop, cha) => {
    if (!value) {
        return value
    }
    const len = value.length
    if (!len) {
        return value
    }
    if (!stop || stop > len) {
        stop = len
    }
    if (start >= stop) {
        return value
    }
    if (!start) {
        start = 0
    }
    if (!cha) {
        cha = '*'
    }
    let replaceStr = ''
    for (let i = start; i < stop; i++) {
        replaceStr += cha
    }
    return value.substring(0, start) + replaceStr + value.substring(stop)
}

export default {
    headimgFilter,
    imageFilter,
    imageParagraphFilter,
    dynamicTimeFilter,
    dateTimeFilter,
    dateFilter,
    replaceFilter,
    sexFilter
}
